import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import pageRepository from '@/features/pages/repositories/PageRepository';
import { usePageStore } from '@/features/pages/stores/usePageStore';
import type { Page } from '@/features/pages/types/page.types';
import { pageKeys } from '@/shared/query/queryKeys';

export function usePagePublishMutation() {
  const queryClient = useQueryClient();
  const setIsDirty = usePageStore(state => state.setIsDirty);

  return useCallback(
    async (id: string, isPublic: boolean) => {
      const detailKey = pageKeys.detail(id);
      const cached = queryClient.getQueryData<Page>(detailKey);
      if (cached) {
        queryClient.setQueryData<Page>(detailKey, { ...cached, isPublic });
      }

      await pageRepository.updateIsPublic(id, isPublic);
      setIsDirty(true);
      void queryClient.invalidateQueries({ queryKey: pageKeys.lists() });
    },
    [queryClient, setIsDirty]
  );
}
